
import { initSoundbiteSlider } from "./../../resources/js/module/soundbiteSlider";
import { initAudioTracks } from "./../../resources/js/module/audio";

$(document).ready(function() {
    initSoundbiteSlider();
    initAudioTracks();
});
